import { useDispatch } from "react-redux";
import "./App.css";
import Header from "./components/header/header";
import Sidebar from "./components/sidebar/sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { currentUserRequest } from "./redux/users/slice";
import { setReturnUrl } from "./utils/SingletonStore";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      localStorage.clear();
      const initialReturnUrl =
        window.location.pathname +
        window.location.search +
        window.location.hash;
      setReturnUrl(initialReturnUrl);
      initialReturnUrl ?
        navigate("/signin?returnUrl=" + encodeURIComponent(initialReturnUrl)) : navigate("/signin")
      return;
    }
    dispatch(currentUserRequest());
  }, [dispatch, navigate]);

  return (
    <>
      <Header />
      <Sidebar />
      <div id="detail" style={{ marginTop: 60, marginLeft: 240, padding: 20 }}>
        <Outlet />
      </div>
    </>
  );
}

export default App;
